import { createReducer, on, Action } from '@ngrx/store'
import * as SelectedItemActions from './selected-item.actions'
import { ITEM_DEFAULTS, ItemsEntity } from './selected-item.models'
import { formatForQuillEditor } from 'libs/gb-dashboard/shared/ui/src/lib/gb-quill-editor/gb-quill-editor-formatter'

export const SELECTED_ITEM_FEATURE_KEY = 'selectedItem'

export interface SelectedItemState {
  item: ItemsEntity | null
  loaded: boolean
  saving: boolean
}

export interface SelectedItemPartialState {
  readonly [SELECTED_ITEM_FEATURE_KEY]: SelectedItemState
}

export const initialSelectedItemState: SelectedItemState = {
  item: null,
  loaded: false,
  saving: false,
}

const reducer = createReducer(
  initialSelectedItemState,
  on(SelectedItemActions.clearSelectedItem, SelectedItemActions.syncSelectedItem, () => ({
    ...initialSelectedItemState,
  })),
  on(SelectedItemActions.syncSelectedItemFailure, (state) => ({
    ...state,
    loaded: true,
  })),
  on(SelectedItemActions.syncSelectedItemSuccess, SelectedItemActions.updateSelectedItemSuccess, (state, { item }) => ({
    item: {
      ...item,
      description: formatForQuillEditor(item.description),
      ioc_shop_label_color: item.ioc_shop_label_color || ITEM_DEFAULTS.iocShopLabelColor,
    },
    loaded: true,
    saving: false,
  })),
  on(
    SelectedItemActions.updateSelectedItem,
    SelectedItemActions.updateItem,
    SelectedItemActions.updateSelectedItemImages,
    SelectedItemActions.createItem,
    SelectedItemActions.placeBid,
    (state) => ({
      ...state,
      saving: true,
    }),
  ),
  on(
    SelectedItemActions.createItemSuccess,
    SelectedItemActions.updateSelectedItemFailure,
    SelectedItemActions.updateItemSuccess,
    SelectedItemActions.updateItemFailure,
    SelectedItemActions.createItemFailure,
    SelectedItemActions.placeBidSuccess,
    SelectedItemActions.placeBidFailure,
    (state) => ({
      ...state,
      saving: false,
    }),
  ),
)

export function selectedItemReducer(state: SelectedItemState | undefined, action: Action) {
  return reducer(state, action)
}
